import { Loading } from 'components/Loading'
import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useUserCurrentQuery } from 'services/users'
import { EOrganizationType } from 'types/users'

type Props = {
  children: ReactNode
  roles: string[]
  orgType?: EOrganizationType
}

const ProtectedRoute = ({ children, roles, orgType }: Props) => {
  const { data: user, isLoading } = useUserCurrentQuery()
  const location = useLocation()

  if (isLoading) {
    return <Loading />
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  const userHasRequiredRole =
    user.userRoles?.some((role) => roles.includes(role)) &&
    (!orgType || user.organizationType === orgType)

  if (!userHasRequiredRole) {
    return <Navigate to="/portal" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
